<template>
  <div class="contents">
      <div class="user">
        <div class="user-item">
            <div class="title">他们都在用维码器</div>
           <div class="write">They're all use WEIMAQI</div>
        </div>
        <div class="port">
            <img src="./images/cologo.png" alt="" oncontextmenu="return false;" onselectstart="return false;" class="img1">
            <img src="./images/phone/Team_Logo.png" alt="" class="img2">
        </div>
    </div>
  </div>
</template>
<script>
export default {
  name:'user',
}
</script>

<style scoped>
.contents{
    width:100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.user{
    width: 1200px;
	height: 675px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
        margin: 100px 0px 50px;
}
.user-item{
        align-items: center;
    display: flex;
    flex-direction: column;
}
.title{
    font-family: 微软雅黑;
font-size: 50px;
font-weight: normal;
font-stretch: normal;
letter-spacing: 5px;
color: #333;
height: 50px;
line-height: 50px;
    /* margin-top:110px; */
}
.write{
    height: 15px;
    line-height: 15px;
font-family: Arial;
font-size: 14px;
letter-spacing: 1px;
color: #333333;
margin-top:20px;
}
.port{
    width: 1200px;
height: 486px;
margin-bottom: 100px;
}
.port img{
        width: 100%;
    }
.port .img2{
    display: none;
}
@media screen and (max-width:1024px){
    .port{
      width: 1000px;
    }
    .port img{
        width: 100%;
    }
    .contents{
        overflow-x: hidden;
    }
}
/* 手机 */
@media screen and (max-width:768px){
    .contents{
        width: 100%;
        height: auto;
    }
    .user{
        width: 100%;
        height: auto;
        justify-content: center;
        margin:0px;
    }
    .user .title{
    font-size: 22px;
	letter-spacing: 0.5px;
	color: #000000;
    margin-top: 50px;
    height: 22px;
    line-height: 22px;
    }
    .user .write{
    font-size: 11px;
	color: #000000;
    margin-top: 14px;
    letter-spacing: 0px;
    height: 11px;
    line-height: 11px;
    }
    .port{
        width: 90%;
    margin: 50px 0px;
    height: auto;
    }
    .port .img1{
        display: none;
    }
    .port .img2{
    display: block;
    width: 100%;
}
}
</style>




// WEBPACK FOOTER //
// src/components/coopera/user.vue